import { AxiosResponse } from 'axios';
import { snakeCaseKeys } from 'helpers/utils';
import { get, post, remove } from 'services/api';
import { IDivorcesFormData } from 'views/public/DivorcesView/components/DivorcesForm/types';

export const getAll = (
  limit: number,
  page: number,
  search: string,
  sortKey: string,
  sortType: string,
): Promise<AxiosResponse> =>
  get(
    `divorces?limit=${limit}&page=${page}&search=${search}&sortKey=${sortKey}&sortType=${sortType}`,
  );

export const getForm = (): Promise<AxiosResponse> => get('divorces/form');

export const getOne = (id: string): Promise<AxiosResponse> => get(`divorces/${id}`);

export const save = (data: IDivorcesFormData, id: string): Promise<AxiosResponse> => {
  const formData = new FormData();
  formData.append(
    'husband',
    JSON.stringify(snakeCaseKeys(data.husband as unknown as Record<string, unknown>)),
  );
  if (data.husband?.idCardFile) formData.append('husband_id_card_file', data.husband.idCardFile);
  if (data.husband?.idCardBackFile)
    formData.append('husband_id_card_back_file', data.husband.idCardBackFile);
  if (data.husband?.ketubaFile) formData.append('husband_ketuba_file', data.husband.ketubaFile);
  if (data.husband?.marriageCertificateFile)
    formData.append('husband_marriage_certificate_file', data.husband.marriageCertificateFile);
  formData.append(
    'wife',
    JSON.stringify(snakeCaseKeys(data.wife as unknown as Record<string, unknown>)),
  );
  if (data.wife?.idCardFile) formData.append('wife_id_card_file', data.wife.idCardFile);
  if (data.wife?.idCardBackFile)
    formData.append('wife_id_card_back_file', data.wife.idCardBackFile);
  if (data.wife?.ketubaFile) formData.append('wife_ketuba_file', data.wife.ketubaFile);
  if (data.wife?.marriageCertificateFile)
    formData.append('wife_marriage_certificate_file', data.wife.marriageCertificateFile);
  if (data.files && Object.values(data.files)) {
    Object.values(data.files).forEach((file) => {
      formData.append('files[]', file);
    });
  }
  formData.append('wedding_temple', data.weddingTemple);
  formData.append('wedding_date', data.weddingDate);
  if (data.ketubaFile) formData.append('ketuba_file', data.ketubaFile);
  if (data.marriageCertificateFile)
    formData.append('marriage_certificate_file', data.marriageCertificateFile);
  if (data.divorceCertificateFile)
    formData.append('divorce_certificate_file', data.divorceCertificateFile);
  if (data.comments) formData.append('comments', data.comments);
  if (id) formData.append('_method', 'PUT');
  return post(`divorces${!id ? '' : `/${id}`}`, formData, { transformRequest: () => formData });
};

export const softDelete = (id: string): Promise<AxiosResponse> => remove(`divorces/${id}`);

export const softDeleteFile = (id: string, fileId: string): Promise<AxiosResponse> =>
  remove(`divorces/${id}/files/${fileId}`);
